module.exports = __webpack_public_path__ + "static/media/aplicacao.1d750111.png";